<template>
  <div id="sidebarMenu" :class="['np-sidebar', {'collapsed':isCollapsed}]">

    <div class="np-brand">
      <div class="np-brand_title">Nex<span>P</span>lan<span>.</span></div>
      <div class="np-brand_subtitle">For One, For Team, For Corporates</div>
    </div>

    <div class="np-group np-border-radius-0 np-group-column np-flex-1">
      <ul class="np-sidebar-nav np-rounded-bottom np-pb-2">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" href="/" :class="{ 'active' : this.inDashboard == 'dashboard'}">
            <svg class="icon"><use href="@/assets/images/icons/dashboard.svg#icon"></use></svg>{{ $t("UI.sidebar.dashboard")}}
          </a>
        </li>          
        <!--        
        <li class="nav-item">
          <a class="nav-link" href="/companies" :class="{ 'active' : this.inDashboard == 'companies'}">
            <img src="@/assets/images/dashboard/task-all.svg" />{{ $t("UI.sidebar.companies")}}
          </a>
        </li>          
        <li class="nav-item" v-if="companiesCount > 0">
          <a class="nav-link align-items-center" href="#">
            <img src="@/assets/images/dashboard/task-all.svg" />{{ $t("UI.sidebar.companies")}} <span class="tag tag-primary">1</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link align-items-center" href="#">
            <img src="@/assets/images/dashboard/project-all.svg" />{{ $t("UI.sidebar.projects")}}
          </a>
        </li>
        -->          
        <li class="nav-item">
          <a class="nav-link" href="/team" :class="{ 'active' : this.inDashboard == 'team'}">
            <svg class="icon"><use href="@/assets/images/icons/team.svg#icon"></use></svg>{{ $t("UI.sidebar.team")}}
          </a>
        </li>
        <!-- 
        <li class="nav-item">
          <a class="nav-link disabled" href="#">
            <img class="icon" src="@/assets/images/dashboard/settings.svg" />{{ $t("UI.sidebar.templates")}}
          </a>
        </li>          
        -->
        <li class="nav-item">
          <a class="nav-link" href="/messages">
            <svg class="icon"><use href="@/assets/images/icons/message.svg#icon"></use></svg>{{ $t("UI.sidebar.messages")}}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/admin" :class="{ 'active' : this.inDashboard == 'admin'}">
            <svg class="icon"><use href="@/assets/images/icons/stat.svg#icon"></use></svg>{{ $t("UI.sidebar.admin")}}
          </a>
        </li>         
        <!--
        <li class="nav-item">
          <a class="nav-link" href="/settings" :class="{ 'active' : this.inDashboard == 'settings'}">
            <img src="@/assets/images/dashboard/settings.svg" />{{ $t("UI.sidebar.settings")}}
          </a>
        </li>                   
        -->
      </ul>

      <h6 class="np-sidebar-heading np-mt-4">
        <span>{{ $t('UI.sidebar.recent') }}</span>
      </h6>
      <ul class="np-sidebar-nav np-transparent np-p-2 mb-2" v-if="recentProjects && recentProjects.length > 0">
        <li class="nav-item"  v-for="(rProject, index) in recentProjects" :key="rProject.id">
          <a class="nav-link" :href="'/project/' + rProject.id" :class="{ 'active' : project && rProject.id === project.id}"  v-if="index < 3">
            <span data-feather="file-text"></span>
            {{ rProject.name }}
          </a>
        </li>
      </ul>
    </div>

    <div class="np-sidebar-nav np-pl-2 np-pt-4 np-pb-4 np-pr-2 align-items-center">
      <span class="image" style="position: relative; margin-top: -45px;"><img src="@/assets/images/dashboard/diamond.png" /></span>
      <h2 style="margin:0; font-size: 16px; font-weight: 600; color: #FFF; padding-top: 19px;">{{ $t('UI.sidebar.toProHeader') }}</h2>
      <h2 style="margin:0; font-size: 12px; font-weight: 300; color: #FFF; text-align: center; padding: 19px 0;">{{ $t('UI.sidebar.toProSubHeader') }}</h2>
      <span class="w-100"><button class="np-btn np-btn-info w-100">{{ $t('UI.sidebar.toProButton') }}</button></span>
    </div>
    <ul class="np-sidebar-nav np-transparent np-pt-1 np-pb-1 np-mt-4">
        <li class="nav-item">
          <button class="nav-link">
            <svg><use href="@/assets/images/icons/collapse.svg#icon"></use></svg>
            {{ $t("UI.sidebar.collapse")}}
          </button>
        </li>
    </ul>   
  </div>
</template>

<script>
  import { useUserStore } from '@/stores/userStore'
  import LanguageSwitcher from '../LanguageSwitcher.vue'

  export default {
      components: {
          LanguageSwitcher
      },    
      name: 'CobaltSidebar',
      props: ['isCollapsed', 'active', 'companiesCount', 'project'],
      data() {
        return {
          inDashboard: '',
          isLoading: true,
          recentProjects: []
        }
      },        
      async beforeMount() {
        this.loadRecentProjects()
      },
      mounted() {
        this.inDashboard = this.$route.name
      },  
      computed: {
        userStore() {
          return useUserStore()
        }
      },               
      methods: {
        async loadRecentProjects() {
          this.isLoading = true

          this.recentProjects = await this.userStore.recentProjects()

          this.isLoading = false
        },
        refresh() {
          this.loadRecentProjects()
        }
      },
  }
</script>